function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.566 3.934a.8.8 0 010 1.132L8.63 12l6.935 6.934a.8.8 0 01-1.132 1.132l-7.5-7.5a.8.8 0 010-1.132l7.5-7.5a.8.8 0 011.132 0z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgCaretleft;